import { create } from 'zustand'
import type {
  Expense,
  ExpensesCategory,
} from '@/features/expenses/types/expenses'

type State = {
  expenses: Array<Expense>
  categories: Array<ExpensesCategory>

  // Expense management
  setExpenses: (expenses: Array<Expense>) => void
  addExpense: (expense: Expense) => void
  updateExpense: (expense: Expense) => void
  removeExpense: (expenseId: string) => void

  // Category management
  setCategories: (categories: Array<ExpensesCategory>) => void
  addCategory: (category: ExpensesCategory) => void
  updateCategory: (category: ExpensesCategory) => void
  removeCategory: (categoryId: string) => void
}

const initialExpenses: Array<Expense> = []

const initialCategories: Array<ExpensesCategory> = []

export const useExpensesStore = create<State>((set, get) => ({
  expenses: initialExpenses,
  categories: initialCategories,

  // Stock actions
  setExpenses: (expenses) => set({ expenses }),
  addExpense: (expense) => {
    set({ expenses: [...get().expenses, expense] })
  },
  updateExpense: (expense) => {
    set({
      expenses: get().expenses.map((x) =>
        x._id === expense._id ? { ...x, ...expense } : x,
      ),
    })
  },
  removeExpense: (expenseId) =>
    set({
      expenses: get().expenses.filter((x) => x._id !== expenseId),
    }),

  // Category actions
  setCategories: (categories) => set({ categories }),
  addCategory: (category) => {
    set({ categories: [...get().categories, category] })
  },
  updateCategory: (category) => {
    set({
      categories: get().categories.map((c) =>
        c._id === category._id ? { ...c, ...category } : c,
      ),
    })
  },
  removeCategory: (categoryId) =>
    set({
      categories: get().categories.filter((c) => c._id !== categoryId),
    }),
}))
